import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EmissionRegisterSuccessAction,
  EmissionRegisterSuccessViewModel,
} from '../emission-register-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-emission-register-success',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-emission-register-success.component.html',
  styleUrls: ['./modal-emission-register-success.component.scss'],
})
export class ModalEmissionRegisterSuccessComponent {
  @Input() open = false;
  @Input() viewModel: EmissionRegisterSuccessViewModel = {
    title: 'Emissão enviada para verificação.',
    description: '',
    projectName: '',
    sentDateLabel: '',
    statusLabel: 'Pendente de verificação do auditor',
  };

  @Output() action = new EventEmitter<EmissionRegisterSuccessAction>();

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onNewEmission(): void {
    this.action.emit('new-emission');
  }

  onConsultEmission(): void {
    this.action.emit('consult');
  }
}
